const roles = {
  superadmin: {
    description:
      'Super Admin CDVI - Tiene acceso a todas las funciones y configuraciones.',
  },
  customer_support: {
    description:
      'Soporte cliente CDVI - Tiene acceso a las funciones y configuraciones de soporte al cliente.',
  },
  administration: {
    description: 'Administración CDVI - Tiene acceso a ???.',
  },
  marketing: {
    description: 'Marketing CDVI - Tiene acceso a ???.',
  },
  dealer_administrator: {
    description:
      'Administrador de concesionario - Tiene acceso a todas las funciones del concesionario.',
  },
  dealer_accounts_manager: {
    description:
      'Gestor de cuentas de concesionario - Tiene acceso a la gestión de cuentas de concesionario.',
  },
  account_administrator: {
    description:
      'Administrador de cuenta - Tiene acceso a todas las funciones de la cuenta.',
  },
  account_site_manager: {
    description:
      'Gestor de sitio de cuenta - Tiene acceso a todas las funciones del sitio de la cuenta.',
  },
  account_door_manager: {
    description:
      'Gestor de puerta de cuenta - Tiene acceso a las funciones de gestión de puertas.',
  },
};

export default roles;
